import React from "react";

const HistoryApply = () => {
  return <div>HistoryApply</div>;
};

export default HistoryApply;
